module.exports = __webpack_public_path__ + "static/media/opakowania_1_C.c8187e58.png";